<template>
    <el-container class="task-detail">
        <el-header>
            <Header></Header>
        </el-header>
        <el-main>
            <div class="task-detail-header">
                <h3>任务明细</h3>
            </div>
            <div class="task-detail-content">
                <table class="table">
                    <thead>
                        <tr v-if="typeof taskDetailData !== 'undefined' && typeof taskDetailData[0] !== 'undefined'">
                            <th>订单号</th>
                            <th>ID</th>
                            <th v-for="(param, indexP) in parameterDataHead" :key="indexP" style="padding: 8px 5px;">
                                {{judgeParamName(param)}}
                            </th>
                            <th>开/平</th>
                            <th>预差比</th>
                            <th>
                                <div>
                                    <span v-for="(item, index) in tradeResultList" :key="index">{{item}}</span>
                                </div>
                            </th>
                            <th>实差比</th>
                            <th>创建时间</th>
                            <th>状态</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, index) in taskDetailData" :key="index" :style="{'border-left': '2px solid '+colorList[index], 'background-color': colorList[index]}" :id="'bgc-color-'+index">
                            <td>
                                <el-tooltip effect="dark" :content="item.client_id" placement="top-start">
                                    <el-button>{{reduceStr(item.client_id)}}</el-button>
                                </el-tooltip>
                            </td>
                            <td>{{item.task_id}}-{{item.task_children_id}}</td>
                            <td class="table-parameter"  v-for="(param, indexP) in orderParamName" :key="indexP" style="padding: 8px 5px; background-color: ''">
                                <span v-if="param == 'otype'" :style="{'color': colorJudge(parameterData(JSON.parse(item.cparam))[param])}">{{joinStr(parameterData(JSON.parse(item.cparam))[param], param)}}</span>
                                <span v-else-if="param == 'spread'">{{handleParam(parameterData(JSON.parse(item.cparam))[param])}}</span>
                                <span v-else>{{joinStr(parameterData(JSON.parse(item.cparam))[param], param)}}</span>
                            </td>
                            <td :rowspan="cellTogether(detailLocation[index])">{{positionJudge(JSON.parse(item.cparam))}}</td>
                            <td>{{priceMargin(item.cparam, index, item)}}</td>
                            <td class="table-result" style="background-color: ''">
                                <div v-if="typeofNum(item.result)">
                                    <span v-for="(param, indexP) in JSON.parse(item.result)" :key="indexP">{{joinResultStr(param, indexP)}}</span>
                                </div>
                                <div v-else>
                                    <span style="margin: 0 auto;">{{item.result}}</span>
                                </div>
                            </td>
                            <td>{{realPriceMargin(item.result, index, item)}}</td>
                            <td>{{item.createtime}}</td>
                            <td>{{orderStatus(item.status_)}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="task-detail-foot">
                <div>
                    <el-button @click="leftEvent"><i class="fa fa-caret-left" aria-hidden="true"></i></el-button>
                    <label>{{pages}}</label>
                    <el-button @click="rightEvent"><i class="fa fa-caret-right" aria-hidden="true"></i></el-button>
                    <span>共 {{totalPages}} 页每页</span>
                    <input type="text" v-model="dataNum" @blur="inputBlur"> 条
                </div>
            </div>
        </el-main>
        <!-- <Footer ref="taskDetailFoot"></Footer> -->
    </el-container>
</template>

<script>
/* eslint-disable */
import Header from '@/components/header/Header.vue'
import Footer from '@/components/Footer/Footer.vue'
import { get } from '@/api/index'
import { mapState } from 'vuex'
import { setTimeout } from 'timers';

export default {
    components: {
        Header,
        Footer
    },
    data() {
        return {
            taskId: '',
            pages: 1,
            totalPages: '',
            headerList: ['订单号', '任务', '子任务', '交易参数', 
                        '交易结果', '创建时间', '订单状态'],
            tradeParamList: ['API', '交易所', '类型', '方式', '限价', '币对', '阈值','出价', '出量'],
            tradeResultList: ['用时', '成价', '成量', '手续费', '交易额'],
            taskDetailData: [],
            dataNum: 100,
            pairingIdList: [],
            colorCount: ['#262829', '#253238', '#2F3233', '#383a3e'], // 黑 蓝 灰
            colorList: [],
            transactionTypeList: [],
            detailLocation: [],
            isDlt: false,
            last_color: '',

            orderParamName: [],
        }
    },
    mounted() {
        this.taskId = this.$route.query.id;
        this.getTaskDetail();
        
    },
    computed: {
        ...mapState([
            'tradeTypeObj'
        ]),
        
        // parameter 生成 table header
        parameterDataHead: function () {
            var this_data = JSON.parse(this.taskDetailData[0]['cparam']);
            delete this_data.price1;
            delete this_data.order_type;
            var this_data_list = Object.keys(this_data);
            if (!this_data_list.includes('dlt')) {// 不含有dlt
                this_data_list.push('dlt');
            }
            this.orderParamName = this_data_list;
            return this_data_list;
        },
    },
    methods: {
        // 获取任务明细数据
        getTaskDetail() {
            var url = this.$url_CM + '/changeServer/changerecords';
            var param = {
                'task_id': this.taskId,
                'bars': this.dataNum,
                'page_num': this.pages
            };
            get(url, param).then(resp => {
                if (!resp.data.datas) {
                    this.$notify.error({
                        message: '没有交易数据',
                        title: '提示',
                        offset: 100,
                        duration: '1000'
                    })
                    setTimeout(() => {
                        this.$router.go(-1);
                    }, 800)
                } else {
                    this.totalPages = resp.data.pages;
                    this.taskDetailData = resp.data.datas;
                    this.pairingIdList = [];
                    if (this.taskDetailData !== null) {
                        for (var i=0; i<this.taskDetailData.length; i++) {
                            this.pairingIdList.push(this.taskDetailData[i].pairing_id)
                            this.transactionTypeList.push(JSON.parse(this.taskDetailData[i].cparam).acc_type)
                        }
                        this.detailColor()
                    }
                }
            })
        },

        // 前一页
        leftEvent() {
            if (this.pages >= 2) {
                this.pages --;
                this.getTaskDetail();
            } else {
                this.$notify.error({
                    message: '已经是第一页了!',
                    title: '提示',
                    offset: 100
                })
            }
        },

        // 后一页
        rightEvent() {
            if (this.pages < this.totalPages) {
                this.pages ++;
                this.getTaskDetail();
            } else {
                this.$notify.error({
                    message: '已经是最后一页了！o(╯□╰)o',
                    title: '提示',
                    offset: 100
                })
            }
        },
        // theader 处理
        jurdeName(name) {
            if (name == '交易请求参数') {
                var name_str = '';
                this.tradeParamList.map(value => {
                    name_str += value + ' | ' 
                })
                return name_str.slice(0, name_str.length-2);
            } else if (name == '交易结果') {
                var name_str = '';
                this.tradeResultList.map(value => {
                    name_str += value + ' | ';
                })
                return name_str.slice(0, name_str.length-2);
            } else {
                return name;
            }
        },

        // 判断订单状态
        orderStatus(status) {
            var status = Number(status);
            if (status == 1) return '创建订单';
            else if (status == 2) return '执行中';
            else if (status == 3) return '完成交易';
            else if (status == 4) return '异常结束';
            else if (status == 5 || status == 6 || status == 7) return '部分成交';
            else if (status == 8) return 'Abnormal';
            return status;
        },

        // param 字符串凭借
        joinStr(data, index) {
            if (index == 'acc_type') return this.tradeTypeObj[data];
            else if (index == 'otype') {// 交易方式
                if (data == 1) return '开多';
                else if (data == 2) return '开空';
                else if (data == 3) return '平多';
                else if (data == 4) return '平空';
                else if (data == 'buy') return '买';
                else if (data == 'sell') return '卖';
                return data;
            } else if (index == 'match_price') {
                if (data == 0) return '限价交易';
                else if (data == 1) return '市价交易';
            } else if (index == 'amount') {
                return data.toFixed(4);
            } else if (index == 'order_type') {
                return;
            } else if (index == 'price1') {
                return;
            }
            else {
                return data;
            }
        },

        // 开 平仓判断
        positionJudge(data) {
            var position = data['otype'];
            if (position == 1 || position == 2) return '开';
            else if (position == 3 || position == 4) return '平';
            return '';
        },

        // 开平仓颜色判断
        colorJudge(position) {
            if (position == 1 || position == 4 || position == 'buy') return '#da5634';
            else if (position == 2 || position == 3 || position == 'sell') return '#1AB394';
        },

        // 单元格合并
        cellTogether(data) {
            // console.log(data)
            // if (data == 'top') return 2;
            // else if (data == 'bottom') return 1;
            // else if (data == 'center') return 1;
            // return 1;
        },

        // result 字符串拼接
        joinResultStr(data, index) {
            return data.toFixed(4);
        },

        // input blur 事件
        inputBlur() {
            this.getTaskDetail();
        },
        // 明细类型判断
        typeofNum(data) {
            if (data == null) return false;
            else if (data[0] == '{') return true;
            return false;
        },

        // 预期价差计算
        priceMargin(data, index, item) {
            var price = JSON.parse(data).price1;
            var pairing_id = this.pairingIdList[index];
            var trans_type = JSON.parse(data).acc_type;

            var count = this.getSameNum(pairing_id);
            var close_to_last = count.arr[1] - count.arr[0];
            var first_id = count.identify[count.arr[0]];
            var last_id = count.identify[count.arr[1]];

            if (first_id == item.id) {// 第一条交易成功的数据 
                if (this.taskDetailData[index+close_to_last]) {
                    var last_data =  JSON.parse(this.taskDetailData[index+close_to_last].cparam);
                    var last_type = last_data['acc_type'];
                    var last_price = last_data['price1'];
                    return this.calculatePrice(trans_type, last_type, price, last_price, 1);
                }
            } else if (last_id == item.id) {// 最后一条交易成功的数据
                if (this.taskDetailData[index-close_to_last]) {
                    var last_data =  JSON.parse(this.taskDetailData[index-close_to_last].cparam);
                    var last_type = last_data['acc_type'];
                    var last_price = last_data['price1'];
                    return this.calculatePrice(trans_type, last_type, price, last_price, 0);
                }
            }
        },

        // 真实价差计算
        realPriceMargin(data, index, item) {
            if (data) {
                if (data[0] == "{") {
                    var price = JSON.parse(data).deal_price; // 当前价格
                    var pairing_id = this.pairingIdList[index]; // 当前 pairing_id
                    var trans_type = this.transactionTypeList[index]; // 当前交易类型
    
                    var count = this.getSameNum(pairing_id);  // 当前 pairing_id 相同的数量
                    var trade_status_list = count.arr; // 交易成功订单在当前配对订单的位置列表
                    if (trade_status_list.length == 0 || trade_status_list.length == 1) {
                        // 配对订单中没有完成完成交易的订单或者只有一个交易完成的订单
                        return '';
                    } else {

                        var close_to_last = count.arr[1] - count.arr[0];
                        var first_id = count.identify[count.arr[0]];
                        var last_id = count.identify[count.arr[1]];
    
                        if (first_id == item.id) {// 第一条交易成功的数据 
                            if (this.taskDetailData[index+close_to_last]) {
                                var last_data =  JSON.parse(this.taskDetailData[index+close_to_last].cparam);
                                var last_type = last_data['acc_type']; // 获取上一条数据的交易类型
                                var last_result_data = this.taskDetailData[index+close_to_last].result;
        
                                if (last_result_data && last_result_data[0] == '{') {
                                    var last_price = JSON.parse(last_result_data).deal_price;
                                    return this.calculatePrice(trans_type, last_type, price, last_price, 1);
                                }
                            }
                        } else if (last_id == item.id) {// 最后一条交易成功的数据
                            if (this.taskDetailData[index-close_to_last]) {
                                var last_data =  JSON.parse(this.taskDetailData[index-close_to_last].cparam);
                                var last_type = last_data['acc_type']; // 获取上一条数据的交易类型
                                var last_result_data = this.taskDetailData[index-close_to_last].result;
        
                                if (last_result_data && last_result_data[0] == '{') {
                                    var last_price = JSON.parse(last_result_data).deal_price;
                                    return this.calculatePrice(trans_type, last_type, price, last_price, 0);
                                }
                            }
                        }
                    }
                } else {
                    return 'NULL';
                }
            }
        },

        // 明细配对颜色区分
        detailColor() {
            for (var i=0; i<this.pairingIdList.length; i++) {
                var real_id = this.pairingIdList[i];

                if (real_id == null) {// 没有id，为灰色
                    this.colorList.push('#383a3e');
                    this.detailLocation.push('center');
                    continue;
                }
                if (i > 0) {
                    var last_id = this.pairingIdList[i-1];
                } 
                if (i < this.pairingIdList.length-1) {
                    var next_id = this.pairingIdList[i+1];
                }

                if (real_id !== last_id) {// id不同时，上一个的背景颜色
                    this.last_color = this.colorList[i-1];
                }

                // 上一个颜色的索引
                var last_color_index = this.colorCount.indexOf(this.last_color);
                if (last_color_index == 2 || last_color_index == 3) {// 颜色在 0 1 2 之间循环
                    var color_index = 0;
                } else {
                    var color_index = last_color_index +1;
                }
                if (real_id == last_id) {
                    // 当前id=上一个id，将当前id、上一个id一起赋予color
                    this.detailLocation.push('top');
                    this.detailLocation.push('bottom');
                    this.colorList.push(this.colorCount[color_index]);
                } else {// 不等于上一个id
                    this.colorList.push(this.colorCount[color_index]);
                    this.detailLocation.push('center')
                }
            }
        },

        // 计算不同的价差
        calculatePrice(name, otherName, price, otherPrice, location) {
            // {'SS': '现货', 'CW': '本周', 'NW': '次周', 'CQ': '季度', 'CS': '永续'}
            var transTypeArr = ['CQ', 'NW', 'CW', 'CS', 'SS'];
            // 获取当前和其他数据的索引
            var index_now = transTypeArr.indexOf(name);
            var index_other = transTypeArr.indexOf(otherName);
            var otherPrice = Number(otherPrice);
            var price = Number(price);
            if (index_now < index_other) {
                // 当前的 index 小时，价差比 = (大 - 小) / 大
                return ((price - otherPrice) / otherPrice*100).toFixed(4) + '%';
            } else if (index_now > index_other) {
                // 当前的 index 大时，价差比 = (大 - 小) / 大
                return ((otherPrice - price)/price*100).toFixed(4) + '%';
            } else if (index_now == index_other) {
                if (location == 1) {// 第一条数据
                    return Math.abs(((otherPrice - price)/price*100).toFixed(4)) + '%';
                } else {// 最后一条最后一条数据
                    return Math.abs(((price - otherPrice)/otherPrice*100).toFixed(4)) + '%';
                }
                
            }
        },

        parameterData(param) {
            delete param.order_type;
            delete param.price1;
            if (this.isDlt) {
                if (!param.hasOwnProperty('dlt')) {
                    // 不包含这个字段
                    param['dlt'] = 'NULL';
                }
            }
            return param;
        },

        // 字段名字判断
        judgeParamName(name) {
            if (name == 'apiid') return 'API';
            else if (name == 'bourse_name') return '交易所';
            else if (name == 'acc_type') return '类型';
            else if (name == 'otype') return '方式';
            else if (name == 'match_price') return '限价';
            else if (name == 'instrument_id') return '币对';
            else if (name == 'dlt') {
                this.isDlt = true;
                return '阈值';
            } else if (name == 'price') return '出价';
            else if (name == 'amount') return '出量';
            else if (name == 'spread') return '限差比';
            return name;
        },

        // 判断数组中相同元素出现的次数
        getSameNum(id) {
            /**
             * param: pairing_id 
             * return: object 当前订单出现次数，订单完成交易的位置，  订单id号列表
             */
            var count = 0;  // 相同id出现的次数
            var order_obj = {};
            var status_list = [];  // 订单完成交易的位置
            var id_list = []; // 订单id号列表

            for (var i=0; i<this.pairingIdList.length; i++) {
                if (this.pairingIdList[i] == id) {// 找到当前pairing_id在列表中的所有id=pairing_id的订单
                    id_list.push(this.taskDetailData[i].id);
                    if (String(this.taskDetailData[i].status_) == '3') {
                        // 订单状态为完成交易
                        status_list.push(count);
                    };
                    count ++;
                }
            }
            order_obj['count'] = count; 
            order_obj['arr'] = status_list;
            order_obj['identify'] = id_list;
            return order_obj;
        },

        // 保留位数
        handleParam(value) {
            if (value) {
                if (typeof value == 'number') {
                    return value.toFixed(4);
                }
            }
        },

        // 字符串缩减
        reduceStr(str) {
            let str_len = str.length-1;
            return '...'+str.slice(str_len-3);
        }
    }
}
</script>

<style lang="scss">
    .task-detail{
        .el-main{
            padding: 0 20px;
            min-height: 650px;
            margin-top: 15px;
            .task-detail-header{
                background-color: #262829;
                h3{
                    padding: 10px;
                    color: #97979a;
                    text-align: left;
                }
            }
            .task-detail-content{
                margin: 10px 0;
                table{
                    font-size: 12px;
                    border-collapse: collapse;
                    thead{
                        tr{
                            th{
                                font-size: 12px;
                                div{
                                    display: flex;
                                    justify-content: space-between; 
                                }
                            }
                        }
                    }
                    tbody{
                        tr{
                            td{
                                font-size: 12px;
                                .el-button{
                                    padding: 0;
                                    opacity: 0.5;
                                    background-color: transparent;
                                    border: 0;
                                    font-size: 12px;
                                    color: #97979a;
                                }
                            }
                            .table-parameter{
                                height: 100%;
                                text-align: center;
                                span{
                                    margin: 0 10px;
                                }
                                div{
                                    display: flex;
                                    justify-content: space-between;
                                }
                            }
                            .table-result{
                                span{
                                    margin: 0 10px;
                                }
                                div{
                                    display: flex;
                                    justify-content: space-between; 
                                }
                            }
                        }
                    }
                }
            }
            .task-detail-foot{
                margin: 10px 0 20px 0;
                div{
                    color: #97979a;
                    font-size: 13px;
                    input{
                        width: 20px;
                        outline: 0;
                        border: 1px solid #000;
                        background-color: #000;
                        padding: 0 5px;
                        font-size: 12px;
                        color: #97979a;
                    }

                    label{
                        margin: 0 5px;
                        line-height: 32px;
                        height: 32px;
                        color: #97979a;
                    }
                    i{
                        font-size: 20px;
                    }
                    .el-button{
                        padding: 5px;
                    }
                }
            }
        }
    }
</style>
